import { createContext, PropsWithChildren, useContext, useMemo, useState } from 'react';

type PatientAppBarContext = {
  showUrgentHelp: boolean;
  setShowUrgentHelp: (open: boolean) => void;
  withIllustration: boolean;
  setWithIllustration: (show: boolean) => void;
};

const patientAppBarContext = createContext<PatientAppBarContext>({
  showUrgentHelp: false,
  setShowUrgentHelp: () => undefined,
  withIllustration: false,
  setWithIllustration: () => undefined,
});

const usePatientAppBarContext = () => useContext(patientAppBarContext);

const PatientAppBarProvider = ({ children }: PropsWithChildren) => {
  const [showUrgentHelp, setShowUrgentHelp] = useState(false);
  const [withIllustration, setWithIllustration] = useState(false);

  const value = useMemo(
    () => ({
      showUrgentHelp,
      setShowUrgentHelp,
      withIllustration,
      setWithIllustration,
    }),
    [showUrgentHelp, setShowUrgentHelp, withIllustration, setWithIllustration]
  );

  return <patientAppBarContext.Provider value={value}>{children}</patientAppBarContext.Provider>;
};

export { PatientAppBarProvider, usePatientAppBarContext };
